import Icon from 'veui/components/Icon'
import { IconOutstanding } from 'dls-icons-vue'

Icon.register('outstanding', IconOutstanding)
